import * as types from './mutations_types';

const actions = {
  myWebSocket: ({commit}, myWebSocket) => {
    commit(types.MY_WEBSOCKET, myWebSocket);
  },
  timerMyWebSocketTimeOut: ({commit}, timerMyWebSocketTimeOut) => {
    commit(types.TIMER_MYWEBSOCKET_TIMEOUT, timerMyWebSocketTimeOut);
  },
  timerMyWebSocketHeart: ({commit}, timerMyWebSocketHeart) => {
    commit(types.TIMER_MYWEBSOCKET_HEART, timerMyWebSocketHeart);
  },
  timerMyWebSocketTimeInter: ({commit}, timerMyWebSocketTimeInter) => {
    commit(types.TIMER_MYWEBSOCKET_TIMEINTER, timerMyWebSocketTimeInter);
  },
};

export default actions;
